import { render, staticRenderFns } from "./MessageViewer.vue?vue&type=template&id=677377e2&scoped=true&"
import script from "./MessageViewer.vue?vue&type=script&lang=js&"
export * from "./MessageViewer.vue?vue&type=script&lang=js&"
import style0 from "./MessageViewer.vue?vue&type=style&index=0&id=677377e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677377e2",
  null
  
)

export default component.exports